import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const DecreaseIcon = (props: IIcon) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path d="M11.1999 14.4004H10.3471V10.9877H11.1999V14.4004Z" />
            <path d="M7.78718 14.4004H8.63996V7.57305H7.78718V14.4004Z" />
            <path d="M6.07972 14.4004H5.22724V4.80039H6.08002L6.07972 14.4004Z" />
            <path d="M3.52008 14.4004L2.667 14.4004L2.6673 1.60069H3.52008V14.4004Z" />
            <path d="M7.74137 1.9272L13.3273 7.51309L10.7471 7.61525L11.4581 8.32622L14.5381 8.20505L14.6664 4.99722L13.9554 4.28626L13.8481 6.94508L8.28581 1.38277L7.74137 1.9272Z" />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const DecreaseIcon = (props: IIcon) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path d="M11.1999 14.4004H10.3471V10.9877H11.1999V14.4004Z" />
            <path d="M7.78718 14.4004H8.63996V7.57305H7.78718V14.4004Z" />
            <path d="M6.07972 14.4004H5.22724V4.80039H6.08002L6.07972 14.4004Z" />
            <path d="M3.52008 14.4004L2.667 14.4004L2.6673 1.60069H3.52008V14.4004Z" />
            <path d="M7.74137 1.9272L13.3273 7.51309L10.7471 7.61525L11.4581 8.32622L14.5381 8.20505L14.6664 4.99722L13.9554 4.28626L13.8481 6.94508L8.28581 1.38277L7.74137 1.9272Z" />
        </SvgIcon>
    );
};
